import React,{Component} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Anasayfa from "./Sayfa/Anasayfa";
import Sertifikalar from "./Sayfa/Sertifikalar";
import Projeler from "./Sayfa/Projeler";
import Ozgecmis from "./Sayfa/Ozgecmis";
import {Layout} from "./components/Layout";
import {NavigationBar} from "./components/NavigationBar";
class App extends Component {
  render() {
    return (
        <React.Fragment>
          <NavigationBar />
          <Layout>
            <Router>
              <Switch>
                <Route exact path="/" component={Anasayfa}/>
                <Route exact path="/sertifikalar" component={Sertifikalar}/>
                <Route exact path="/projeler" component={Projeler}/>
                <Route exact path="/ozgecmis" component={Ozgecmis}/>
              </Switch>
            </Router>
          </Layout>
        </React.Fragment>
    );
  }
}

export default App;
